import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../Shared/Popup/PopUp';


const TermsPopUp = (props) => {

    return (
        <div className="terms-popup">

            <PopUp showPopUp={props.showPopUp} onClose={() => { props.closePopUp() }}>

                <div className="content">
                    {props.title ? <h1>{props.title}</h1> : ''}

                    <p><b> 1. חשוב שתדעו</b></p>
                    <p>
                        1.1 שירות המתנה נעימה במסלול "ללא הגבלה" כרוך בחיוב חודשי קבוע בסך של ₪14.90 , והינו מתחדש אוטומטית.
                        בנוסף, בחיוג לשירות לצורך החלפת או הורדת שירים תחויב בעלות זמן אוויר בסך של 39 אג' לדקה (להלן: "עלות זמן אוויר"). לידיעתך, תוכל
                        לבצע פעולות אלו גם בפורטל או אתר {window.Config.brand_Name_HE}. החלפת שיר במסלול זה אינה כרוכה בחיוב נוסף, למעט עלות זמן אוויר ו/או גלישה בתוכניתך.
                    </p>
                    <p>
                        1.2 במידה והינך מנוי בשירות המתנה נעימה במסלול "רגיל" ולא במסלול "ללא הגבלה", החיוב החודשי הקבוע הינו בסך ₪9.90 לחודש, וכן תחויב בגין כל הורדת פריט בסך של ₪5.90 וזאת בנוסף לעלות זמן אוויר .
                    </p>
                    <p>
                        1.3 .לא תהא זכאי לזיכוי בגין אי שימוש בשירות ו/או בהורדות מכל סיבה שהיא.
                    </p>
                    <p>
                        1.4 .ניתן לשמור בו זמנית עד 30 שירים במסגרת ניהול השירות.
                    </p>
                    <p>
                        1.5 לתשומת ליבך, בהתנתקות מהשירות הפרופיל והשירים שרכשת יישמרו למשך עד שלושה חודשים בלבד, ולאחר מכן יימחק הפרופיל
                        ולא ניתן לשחזר את השירים.    
                    </p>
                    <p>
                        1.6 .השירות הנו לתקופה בלתי קצובה. הנך רשאי להודיע ל{window.Config.brand_Name_HE} בכל עת על הפסקת השירות.
                    </p>
                    <p>
                        1.7 .{window.Config.brand_Name_HE} רשאית לבטל את השירות ו/או לשנות את תנאיו ותעריפיו מעת לעת.
                    </p>
                    <p>
                        1.8 אין בשימוש בשירות כדי לגרוע מהתחייבות כלשהי שחלה עליך בהתאם לכל הסכם עם {window.Config.brand_Name_HE}. תנאי הסכם זה מצטרפים גם לתנאים המופיעים בנספחי התנאים הכלליים של קבוצת {window.Config.brand_Name_HE} לכל אחד מהשירותים המסופקים לך, המהווים יחד את
                        הסכם ההתקשרות עם {window.Config.brand_Name_HE}.                    
                    </p>
                    <p>
                        <b style={{color: "grey"}}>
                        1.9 .להפסקת השירות או למידע נוסף אנא צור קשר עם שירות הלקוחות ב- {window.Config.technicalSupportPhone} 
                          או באתר www.{window.location.hostname} 
                        </b>
                    </p>
                </div>
            </PopUp>

        </div>
    )
};

const mapStateToProps = (state) => {
    return {
        audio: state.fundialPage.selectedSong,
    };
};

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(TermsPopUp);